/* eslint-disable indent */
import {
  format,
  isWithinInterval,
  parseISO,
} from 'date-fns';

const dateMapping = {
  thisweek: 7,
  thismonth: 30,
  thisyear: 365,
};

export function getRelativeDateRange(param) {
  const endDateTime = new Date();
  const startDateTime = new Date(endDateTime.getTime() - dateMapping[param] * 86400000);
  switch (param) {
    case 'any':
      return `<${format(endDateTime.setDate(endDateTime.getDate() + 1), 'yyyy-MM-dd')}`;
    default:
      return `>${format(startDateTime, 'yyyy-MM-dd')},<${format(
        endDateTime.setDate(endDateTime.getDate() + 1),
        'yyyy-MM-dd',
      )}`;
  }
}

export function convertDatesToFilters(datesArray = [], hasFilterData = false) {
  const result = ['any'];

  const endDateTime = new Date();
  endDateTime.setHours(0, 0, 0, 0);

  const startWeekDateTime = new Date(endDateTime.getTime() - dateMapping.thisweek * 86400000);
  const startMonthDateTime = new Date(endDateTime.getTime() - dateMapping.thismonth * 86400000);
  const startYearDateTime = new Date(endDateTime.getTime() - dateMapping.thisyear * 86400000);

  if (datesArray && datesArray.length > 0) {
    for (let i = 0; i < datesArray.length; i += 1) {
      let date;
      if (hasFilterData) {
        const [year, month, day] = Object.keys(datesArray[i])[0].split('-').map(Number);
        date = new Date(year, month - 1, day);

        if (!result.includes('thisday') && date.getTime() === endDateTime.getTime()) {
          result.push('thisday');
        }
      } else {
        date = parseISO(datesArray[i]);
      }
      if (
        !result.includes('thisyear')
        && isWithinInterval(date, { start: startYearDateTime, end: endDateTime })
      ) {
        result.push('thisyear');
      }
      if (
        !result.includes('thismonth')
        && isWithinInterval(date, { start: startMonthDateTime, end: endDateTime })
      ) {
        result.push('thismonth');
      }
      if (
        !result.includes('thisweek')
        && isWithinInterval(date, { start: startWeekDateTime, end: endDateTime })
      ) {
        result.push('thisweek');
      }
    }
  }

  return result;
}
